import styled, { css } from 'styled-components';

import { styledReset } from '@pkg/primitives';

export const Wrapper = styled.button<{ $selected?: boolean }>`
    ${styledReset.button}

    border-radius: 50px;
    background: rgba(255, 255, 255, 0.1);

    display: flex;
    padding: 5px 10px;
    align-items: center;
    gap: 7px;

    color: rgba(255, 255, 255, 0.5);
    font-size: 14px;
    font-weight: 600;
    line-height: 120%;
    letter-spacing: -0.42px;

    cursor: pointer;
    text-transform: capitalize;
    transition:
        box-shadow 200ms ease,
        background 200ms ease,
        color 200ms ease;

    &:hover {
        box-shadow:
            0 0 68px 0 rgba(255, 255, 255, 0.1) inset,
            0 0 0 1px rgba(255, 255, 255, 0.1) inset;
    }

    ${({ $selected }) =>
        $selected &&
        css`
            color: #fff;
            background: #523df1;
        `}
`;
